import * as React from "react";

type Props = {
    startdate: string;
    currentpaidsalary: string;
    yearlysalary: string;
    company: string;
    currenttyelpayment: string;
    yearlypayment: string;
    paymentpercent: string;

    maintitle: string;
    paymenttitle: string;
    paymenttextupper: string;
    paymenttextlower: string;
    tablefirsttitle: string;
    tablesecondtitle: string;
    tablethirdtitle: string;
};

type State = {

};

export default class PaymentsPanel extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);
    };

    public render() {
        return (
            <section className="payments-panel col-md-8">
                <div className="payments-panel-inner">
                    <h1>{this.props.maintitle}</h1>
                    <h5 dangerouslySetInnerHTML={{ __html: this.props.paymenttitle }}></h5>
                    <p dangerouslySetInnerHTML={{ __html: this.props.paymenttextupper }}></p>

                    <table className="table">

                        <tr>
                            <th>{this.props.tablefirsttitle}</th>
                            <th>{this.props.tablesecondtitle}</th>
                            <th>{this.props.tablethirdtitle}</th>
                        </tr>
                        <tr>
                            <td>{this.props.company}</td>
                            <td>{this.props.currentpaidsalary}</td>
                            <td>{this.props.currenttyelpayment}</td>
                        </tr>
                    </table>
                    <br />
                    <p dangerouslySetInnerHTML={{ __html: this.props.paymenttextlower }}></p>
                </div>
            </section>
        );
    };
}